import React from "react";

import BidNowBuyNowWithFetch from "../BidNowBuyNowWithFetch";
import ProxyBidWithFetch from "../ProxyBidWithFetch";

interface BuyingOptionsProps {
  biddingType: "ProxyBid" | "BidNowBuyNow";
  biddingInfoUrl: string;
  placeBidUrl: string;
  acceptTermsAndConditionsUrl: string;
  isTracked: boolean;
  vrm: string | string[];
  setIsTracked: (value: boolean) => void;
  significantFields: any;
  saleStartDate: string;
  isOnSaleAndOwner: boolean;
  inventoryId: string | null;
  isToUseAuthZero?: boolean;
}

const BuyingOptions: React.FunctionComponent<BuyingOptionsProps> = ({
  biddingType,
  biddingInfoUrl,
  placeBidUrl,
  acceptTermsAndConditionsUrl,
  isTracked,
  vrm,
  setIsTracked,
  significantFields,
  saleStartDate,
  isOnSaleAndOwner,
  inventoryId,
  isToUseAuthZero = false,
}) => {
  return (
    <>
      {!isOnSaleAndOwner && biddingType === "ProxyBid" && (
        <ProxyBidWithFetch
          biddingInfoUrl={biddingInfoUrl}
          placeBidUrl={placeBidUrl}
          acceptTermsAndConditionsUrl={acceptTermsAndConditionsUrl}
          isTracked={isTracked}
          vrm={vrm}
          setIsTracked={setIsTracked}
          significantFields={significantFields}
          saleStartDate={saleStartDate}
          inventoryId={inventoryId}
          isToUseAuthZero={isToUseAuthZero}
        />
      )}
      {biddingType === "BidNowBuyNow" && (
        <BidNowBuyNowWithFetch
          biddingInfoUrl={biddingInfoUrl}
          placeBidUrl={placeBidUrl}
          acceptTermsAndConditionsUrl={acceptTermsAndConditionsUrl}
          isTracked={isTracked}
          vrm={vrm}
          setIsTracked={setIsTracked}
          inventoryId={inventoryId}
          isToUseAuthZero={isToUseAuthZero}
        />
      )}
    </>
  );
};

export default BuyingOptions;
